<script>
import _ from 'lodash'
import Axios from 'axios'
import mobiscroll from '@mobiscroll/javascript'
import elementHandler from './Precosteo/element-handler.vue'
import md5 from "js-md5";


export default {
	components: { elementHandler },
    name: 'CalculoPorReceta',
    props: {
        displayOnly: {
            type: [Boolean],
            default: false
        },
        displayData: {
            type: [Array]
        },
        value: {
            type: [Object],
            default: () => {
                return {
                    "costoGeneral": 0,
                    "precioGeneral": 0,
                    "items": []
                }
            },
            required: false
        },
        elementosId: {
            type: [Number, String],
            required: true
        },
        porciones: {
            type: [Number, String],
            default: 10
        }
    },
    computed: {
        computedCalc(){
            let costoGeneral = 0,
                precioGeneral = 0;
            _.forEach(this.items, item => {
                costoGeneral += item.costo
                precioGeneral += item.precio
            })
            return {
                costoGeneral,
                precioGeneral, 
                items: this.items
            }
        },
        activeURI(){
            return `precosteo/getrecetas4multiply/${this.elementosId}:${this.porciones}`;
        },
        valueMD5() {
			return md5(JSON.stringify(this.value));
		},
        itemsMD5() {
			return md5(JSON.stringify(this.items));
		},
    },
    data: () => {
        return {
            isLoading: false,
            items: [],
            data: {
                receta: [],
                catalogoOpcionesDeMarcas: [],
                conversion_data: [],
            }
        }
    },
    methods: {
        emitCalc(){
            if(this.valueMD5 != this.itemsMD5 && !this.displayOnly){
                this.$emit('input', this.computedCalc)
                this.$emit('updated')
            }
        },  
        async buildItemsConfigs(){
            let configs = []
            _.forEach(this.data.receta, element => {
                // console.log('element', element);
                let toInsert = {

                    // LOCAL INDEX
					localID: _.uniqueId('local-id-'),

                    // cateceras
                    ingrediente: element.ingrediente,
                    categoria: element.categoria,
	
					// PRESENTACION
					idelemento_fk: element.id_pk_ingrediente,
					idpresentacion_fk: null,

					// TIPO Y CONFIGURACIONES
					tipo: element.tipo,
					costo: 0,
					precio: 0,
					total: 0,
					cantidad: 0,
                    
                    // UNIDAD MEDICION RECETA
                    receta_cantidad: element.cantidad,
                    receta_unidadmedicion: element.unidadmedicion_receta,
                    receta_ctrl: element.ctrl,

                    // CHECK Update
					check: true,
                }
                // console.log('element.toInsert', toInsert)
                configs.push(toInsert)
            })
            this.items = configs
        },
        async loadUp(){
            this.isLoading = true
            this.items = []
            if(!this.displayOnly){
                try {
                    let response = await Axios.get(this.activeURI)
                    if(response.status){
                        this.data.receta = response.data.receta
                        this.data.catalogoOpcionesDeMarcas = response.data.catalogoOpcionesDeMarcas
                        this.data.conversion_data = response.data.conversion_data
                        await this.buildItemsConfigs()
                    } else  if (response.msg) {
                        mobiscroll.snackbar({
                            display: 'top',
                            theme: 'ios',
                            message: response.msg,
                            color: response.class,
                            duration: 7000
                        })
                    }
                } catch(e) {
                    console.error(e)
                    mobiscroll.snackbar({
                        display: 'top',
                        theme: 'ios',
                        message: 'Ocurrió un error obteniendo la respuesta: ' + e,
                        color: 'warning',
                        duration: 7000
                    })
                }
            } else {
                console.log('No actualiza desde API en modo displayOnly, en su lugar, carga desde displayData')
                this.items = _.clone(this.displayData)
            }
            this.isLoading = false
        }
    },
    watch: {
        itemsMD5(){
            this.emitCalc()
        },
        elementosId(){
            this.loadUp()
        },
        porciones(){
            this.loadUp()
        }
    },
    mounted(){
        this.loadUp()
    }
}
</script>

<template>
    <div id="CalculoPorReceta">
        <div class="text-center" v-if="isLoading">
            <b-spinner variant="primary" class="ml-auto"></b-spinner>
        </div>
        <div v-else class="content">
            <b-list-group>
                <element-handler v-for="(item, $index) in items" :key="item.localID"
                    v-model="items[$index]"
                    :displayOnly="displayOnly"
                    :fullRequerimientosCalculo="data.receta" 
                    :fullFactoresDeConversion="data.conversion_data" 
                    :fullCatalg="data.catalogoOpcionesDeMarcas"/>
            </b-list-group>
            <!-- <pre>
                computedCalc
                {{computedCalc}}
            </pre> -->
        </div>
    </div>
</template>